/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    if (!navigation) return;

    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    const menu = navigation.querySelector('.gh-navigation-menu');
    const desktopQuery = window.matchMedia('(min-width: 768px)');
    const backgroundElements = Array.from(navigation.parentElement?.children || []).filter(function (element) {
        return element !== navigation;
    });

    const setBackgroundInert = function (inert) {
        backgroundElements.forEach(function (element) {
            element.inert = inert;
        });
    };

    const setButtonState = function (open) {
        burger.setAttribute('aria-expanded', String(open));
        burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    };

    const closeMenu = function (restoreFocus) {
        navigation.classList.remove('is-open');
        document.documentElement.style.overflowY = '';
        setBackgroundInert(false);
        setButtonState(false);

        if (restoreFocus) {
            burger.focus();
        }
    };

    const openMenu = function () {
        navigation.classList.add('is-open');
        document.documentElement.style.overflowY = 'hidden';
        setBackgroundInert(true);
        setButtonState(true);
        if (menu) {
            menu.scrollTop = 0;
            window.requestAnimationFrame(function () {
                menu.scrollTop = 0;
            });
        }
    };

    burger.addEventListener('click', function () {
        if (navigation.classList.contains('is-open')) {
            closeMenu(true);
        } else {
            openMenu();
        }
    });

    document.addEventListener('keydown', function (event) {
        if (!navigation.classList.contains('is-open')) return;

        if (event.key === 'Escape') {
            event.preventDefault();
            closeMenu(true);
            return;
        }

        if (event.key !== 'Tab') return;

        const focusable = Array.from(navigation.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (element) {
            return element.getClientRects().length > 0;
        });
        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    });

    const handleBreakpointChange = function (event) {
        if (event.matches && navigation.classList.contains('is-open')) {
            closeMenu(false);
        }
    };

    if (typeof desktopQuery.addEventListener === 'function') {
        desktopQuery.addEventListener('change', handleBreakpointChange);
    } else {
        desktopQuery.addListener(handleBreakpointChange);
    }

    setButtonState(false);
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();
